﻿import '../Scripts/Vue/index.js';